/**
 * If the current domain is a generic Fireknife domain.
 * If its a generic domain, we do not need to redirect and can use SLUG directly.
 * @returns {boolean} - True if the domain is a generic Fireknife domain, false otherwise.
 */
export function isGenericFireknifeDomain(): boolean {
    const genericDomains = [
        'localhost',
        '127.0.0.1',
        'widget.fire-knife.com',
        'widget-staging.fire-knife.com',
    ];
    const currentDomain = window.location.hostname;
    return genericDomains.includes(currentDomain);
}

export function isDevelopmentEnvironment(): boolean {
    const devDomains = ['localhost', '127.0.0.1'];
    const currentDomain = window.location.hostname;
    return devDomains.includes(currentDomain);
}

export function parseSlugAndShowIdFromUrl(): {
    slug: string | undefined;
    showId: number | undefined;
} {
    // if it's a generic domain it will be directly in the URL, like
    // https://widget.fire-knife.com/slug-showId
    // If it's a custom url, than the GET parameter will be used, like
    // https://example.com/someurl?fireknife=slug-showId

    // Match "<slug>-<showId>". Slugs may contain hyphens (e.g. "my-luau-42"),
    // so the regex anchors to the LAST hyphen before the numeric id.
    if (isGenericFireknifeDomain()) {
        const firstSegment = window.location.pathname.split('/')[1];
        const match = firstSegment && firstSegment.match(/^(.+)-(\d+)$/);
        if (match) {
            return { slug: match[1], showId: parseInt(match[2], 10) };
        }
    }

    const urlParams = new URLSearchParams(window.location.search);
    const fireknifeParam = urlParams.get('fireknife');
    const match = fireknifeParam && fireknifeParam.match(/^(.+)-(\d+)$/);
    if (match) {
        return { slug: match[1], showId: parseInt(match[2], 10) };
    }
    return { slug: undefined, showId: undefined };
}
